export default "__VITE_ASSET__6d1495c9__"